/**
 * Validation and sanitization utilities for form inputs
 * Security measures against XSS and injection attacks
 */

// Phone validation for Russian numbers
export const validatePhone = (phone) => {
  const cleaned = phone.replace(/[\s\-\(\)]/g, '');
  const phoneRegex = /^(\+7|8)?[0-9]{10}$/;
  return phoneRegex.test(cleaned);
};

// Name validation (Cyrillic and Latin, spaces, hyphens)
export const validateName = (name) => {
  const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s\-]{2,50}$/;
  return nameRegex.test(name.trim());
};

// Sanitize input - remove dangerous characters and HTML
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return '';

  return input
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/[<>"'`;(){}[\]\\]/g, '') // Remove dangerous characters
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+=/gi, '') // Remove event handlers
    .slice(0, 1000); // Limit length
};

// Format phone number for display
export const formatPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 11 && (cleaned.startsWith('7') || cleaned.startsWith('8'))) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
  }

  if (cleaned.length === 10) {
    return `+7 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 8)}-${cleaned.slice(8, 10)}`;
  }

  return phone;
};

// Validate form data object
export const validateModalForm = (data) => {
  const errors = {};

  if (!data.name.trim()) {
    errors.name = 'Введите ваше имя';
  } else if (!validateName(data.name)) {
    errors.name = 'Некорректное имя';
  }

  if (!data.phone.trim()) {
    errors.phone = 'Введите номер телефона';
  } else if (!validatePhone(data.phone)) {
    errors.phone = 'Некорректный номер телефона';
  }

  return errors;
};
